// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page-enter-active,.page-leave-active{transition-property:opacity;transition-timing-function:ease-in-out;transition-duration:.1s}.page-enter,.page-leave-to{opacity:0}.slide-left-enter,.slide-right-leave-active{opacity:0;transform:translate(30px)}.slide-left-leave-active,.slide-right-enter{opacity:0;transform:translate(-30px)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
